import { render, staticRenderFns } from "./VarionScannerButton.vue?vue&type=template&id=3f5542b1&scoped=true&"
import script from "./VarionScannerButton.vue?vue&type=script&lang=js&"
export * from "./VarionScannerButton.vue?vue&type=script&lang=js&"
import style0 from "./VarionScannerButton.vue?vue&type=style&index=0&id=3f5542b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5542b1",
  null
  
)

export default component.exports